var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Tooltip } from '@aptive-env/storybook';
import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { format, isEqual, parse } from 'date-fns';
import { useMemo } from 'react';
export var ProductionDemandDataView = function (_a) {
    var weeks = _a.weeks, currentWeek = _a.currentWeek, data = _a.data, onChange = _a.onChange;
    var columns = useMemo(function () { return __spreadArray([
        {
            header: 'Areas',
            accessorKey: 'office.name'
        }
    ], weeks.map(function (week, i) { return ({
        id: format(week.start, 'MM/dd/yyyy'),
        header: function () { return (_jsxs("div", { children: [_jsxs("div", __assign({ className: "text-gray-600" }, { children: ["Week ", i + 1] })), _jsxs("div", __assign({ className: "text-gray-500 h-6 flex items-center rounded-lg px-3 mt-1 ".concat(i + 1 === currentWeek ? 'bg-blue-500 text-white ' : '') }, { children: [format(week.start, 'MM/dd'), " - ", format(week.end, 'MM/dd')] }))] })); },
        accessorFn: function (row) {
            var _a, _b;
            if (Array.isArray(row.targets)) {
                var target = (_a = row.targets) === null || _a === void 0 ? void 0 : _a.find(function (target) { return isEqual(week.start, parse(target.start_date, 'yyyy-MM-dd', new Date())); });
                return (_b = target === null || target === void 0 ? void 0 : target.demand) !== null && _b !== void 0 ? _b : 0;
            }
            return 0;
        }
    }); }), true); }, [currentWeek, weeks]);
    var table = useReactTable({
        columns: columns,
        data: data,
        getCoreRowModel: getCoreRowModel(),
    });
    var handleCellInput = function (event) {
        var inputText = event.currentTarget.innerText;
        var numericText = inputText.replace(/\D/g, '');
        if (inputText !== numericText) {
            event.currentTarget.innerText = numericText;
            // Move the caret to the end after editing
            var range = document.createRange();
            var selection = window.getSelection();
            range.selectNodeContents(event.currentTarget);
            range.collapse(false);
            selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
            selection === null || selection === void 0 ? void 0 : selection.addRange(range);
        }
    };
    var handleCellBlur = function (event, cell) {
        var value = event.target.innerText;
        var demand = Number(value);
        if (!isNaN(demand) && demand > 0) {
            onChange({
                officeId: cell.row.original.office.id,
                startDate: parse(cell.column.id, 'MM/dd/yyyy', new Date()),
                demand: demand,
            });
        }
    };
    return (_jsx("div", __assign({ className: "bg-white rounded-xl border border-gray-200 flex flex-col items-center overflow-hidden" }, { children: _jsx("div", __assign({ className: "w-full h-full overflow-auto relative" }, { children: _jsxs("table", __assign({ className: "border-separate border-spacing-0 w-full" }, { children: [_jsx("thead", { children: table.getHeaderGroups().map(function (headerGroup) { return (_jsx("tr", { children: headerGroup.headers.map(function (header, index) { return (_jsx("th", __assign({ className: "\n                      bg-[#f9fafb] text-gray-600 text-xs font-light uppercase first:text-left p-3 whitespace-nowrap sticky z-[3] top-0\n                      first:border-r first:border-gray-200 first:left-0 first:z-[5] first:bg-[#f9fafb]\n                    " }, { children: header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext()) }), header.id)); }) }, headerGroup.id)); }) }), _jsx("tbody", { children: table.getRowModel().rows.map(function (row) { return (_jsx("tr", { children: row.getVisibleCells().map(function (cell, cellIndex) { return (_jsx("td", __assign({ className: "\n                      text-center first:text-left\n                      border-t border-gray-200 last:border-r-0\n                      first:whitespace-nowrap first:border-r first:sticky first:left-0 first:z-[4] first:bg-white\n                      ".concat(cellIndex < currentWeek && 'bg-[#f9fafb]', "\n                      ").concat(cellIndex === currentWeek - 1 && 'border-r', "\n                    ") }, { children: _jsx("div", __assign({ className: "h-full w-full p-3 outline-blue-500 outline-1 font-light text-[#4B5563] text-sm", contentEditable: cellIndex > 0 && cellIndex >= currentWeek, suppressContentEditableWarning: true, onInput: handleCellInput, onBlur: function (event) { return handleCellBlur(event, cell); } }, { children: cellIndex > 0 && cellIndex < currentWeek ? (_jsx(Tooltip, __assign({ message: "Past weeks uneditable", alignment: "center", position: "top", className: "static" }, { children: _jsx("span", __assign({ className: "font-light text-[#4B5563] text-sm" }, { children: cell.getValue() })) }))) : (_jsx(_Fragment, { children: cell.getValue() })) })) }), cell.id)); }) }, row.id)); }) })] })) })) })));
};
